// BillingSuccess.js
export function BillingSuccess() {
  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.icon}>🎉</div>
        <h1 style={s.title}>You're all set!</h1>
        <p style={s.sub}>Your 30-day free trial has started. No charge until the trial ends.</p>
        <a href="/" style={s.btn}>Go to Dashboard</a>
      </div>
    </div>
  )
}

// BillingCancel.js
export function BillingCancel() {
  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.icon}>👋</div>
        <h1 style={s.title}>No problem!</h1>
        <p style={s.sub}>You can start your free trial anytime from your billing page.</p>
        <a href="/" style={s.btn}>Go to Dashboard</a>
      </div>
    </div>
  )
}

const s = {
  container: {
    minHeight: '100vh', background: '#0a0a0f',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'DM Sans', sans-serif", padding: 20,
  },
  card: {
    background: '#13131a', border: '1px solid #1e1e2e',
    borderRadius: 16, padding: '48px 40px', maxWidth: 400,
    width: '100%', textAlign: 'center',
  },
  icon: { fontSize: 48, marginBottom: 16 },
  title: { color: '#fff', fontSize: 24, fontWeight: 700, margin: '0 0 12px' },
  sub: { color: '#6b6b80', fontSize: 15, margin: '0 0 32px', lineHeight: 1.6 },
  btn: {
    display: 'block', background: '#4f46e5', color: '#fff',
    borderRadius: 8, padding: '13px 0', fontSize: 15,
    fontWeight: 600, textDecoration: 'none',
  },
}
